//import { Dispatch } from "@reduxjs/toolkit";
import { connect } from "react-redux";
import TenantList from "./index";
import { ITenantService } from "@/services/tenant-service/IResourceService.ts";
import { TenantService } from "@/services/tenant-service/TenantService.ts";
import { TenantInfo } from "@/services/tenant-service/entities/TenantEntity.ts";
import { SearchResponse } from "@/services/entities/AxiosMethod.ts";

const mapDispatchToProps = () => {
  const tenantService: ITenantService = new TenantService();
  return {
    onFetchTenantList: async (endpoint: string): Promise<SearchResponse<TenantInfo>> => {
      const response = await tenantService.getTenantList(endpoint);
      // const fakeData: any = [];
      // for(let i = 0; i < 50; i++) {
      //   fakeData.push({
      //     guid: `${i}`,
      //     name: `Tenant ${i}`,
      //     status: "Active",
      //     sequenceNumber: i,
      //     version: "1.0",
      //     databaseConfigOption: "Standard",
      //     licenceInfo: {
      //       expiredTime: "2023-12-31",
      //       licenceType: "Standard",
      //       licenseAvailability: {
      //         externalOrganizations: {
      //           committed: 10,
      //           available: 20,
      //         },
      //         resources: {
      //           committed: 100,
      //           available: 200,
      //         },
      //       },
      //     },
      //   })
      // }
      //const data = fakeData.map(item => new TenantInfo(item));
      //return data;
      return response;
    }
  }
}

export default connect(null, mapDispatchToProps)(TenantList);